<template>
  <div class="max-w-[50rem] p-8 mx-auto w-full h-full relative">
    <DataGetter
      @dataAvailable="
        data => {
          subscription = data?.metaData || {}
        }
      "
      contentId="subscription"
    />
    <div
      class="bg-[#FBFBFC] h-full py-6 rounded-3xl shadow-b-xl"
      v-if="products.length !== 0"
    >
      <div class="h-full px-6 overflow-auto flex flex-col">
        <div class="absolute right-12 top-12" @click="$router.back">
          <img
            src="@/assets/images/all/close.svg"
            class="w-[30px] h-[30px] cursor-pointer full-screen-modal-close-button-black"
            alt=""
          />
        </div>
        <div class="text-center font-bold title-color text-3xl">
          Ajouter un Deal
        </div>
        <div class="py-4"></div>

        <div class="overflow-auto h-full pr-4">
          <div class="flex flex-col gap-4">
            <div
              v-for="(product, i) in products"
              :key="i"
              class="flex items-center gap-6 rounded-2xl p-4 ripple"
              :class="{
                'bg-primary-100 ': selectedProductsIds.includes(product.id),
                'bg-gray-100 ': !selectedProductsIds.includes(product.id),
              }"
              @click="toggleProductSelection(product, i)"
            >
              <div class="w-20 h-20">
                <img
                  :src="product.image"
                  class="w-full h-full object-cover rounded-2xl"
                  alt=""
                />
              </div>
              <div>
                {{ product.name }}
              </div>
              <div class="ml-auto">
                <div class="w-[1.5rem] h-[1.5rem] relative">
                  <div
                    class="duration-300 rounded-lg border-2 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                    :class="{
                      'border-primary w-[1.5rem] h-[1.5rem] bg-primary':
                        selectedProductsIds.includes(product.id),
                      'border-primary-300 w-[1.5rem] h-[1.5rem] bg-[transparent]':
                        !selectedProductsIds.includes(product.id),
                    }"
                  ></div>
                  <div
                    class="duration-300 rounded-lg border-2 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                    :class="{
                      'border-primary w-[1.5rem] h-[1.5rem] bg-[transparent]':
                        selectedProductsIds.includes(product.id),
                      'border-[transparent] w-[1.5rem] h-[1.5rem] bg-[transparent]':
                        !selectedProductsIds.includes(product.id),
                    }"
                  >
                    <img
                      src="@/assets/images/all/check-normal-white.svg"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="pt-4">
          <button
            class="buttonComponent w-full"
            @click="acceptSelectedProducts"
            :class="{
              'pointer-events-none opacity-50': selectedProducts.length == 0,
            }"
          >
            Continuer

            <div
              class="top-0 right-0 translate-x-1/2 -translate-y-1/2 rounded-full absolute w-6 h-6 border border-primary bg-white text-primary"
            >
              {{ selectedProducts.length }}
            </div>
          </button>
        </div>

        <!-- <DealForm @dealSubmitted="handleSubmit" /> -->
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import DealForm from './DealForm.vue'
import DataGetter from '../utils/DataGetter.vue'
import moment from 'moment'

export default defineComponent({
  name: 'AddNewDeal',
  components: {
    DealForm,
    DataGetter,
  },
  data() {
    return {
      eventsIds: [], // Stocke les IDs des écouteurs d'événements
      subscription: {},
      products: [],
      selectedProducts: [],
    }
  },
  mounted() {
    // Écoute des événements pour la création du Deal
    const id = this.$Events.handleEvent('deal_created', this.onDealCreated)
    const id2 = this.$Events.handleEvent(
      'failed_to_create_deal',
      this.onDealCreationFailed,
    )
    this.eventsIds.push(id, id2)
    this.loadProducts()
  },
  beforeUnmount() {
    // Nettoyage des écouteurs d'événements
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    async loadProducts() {
      const data = await this.$Events.sendDataRequestResolve('products')
      if (!data?.length) {
        this.$Events.dispatchEvent('toast_notification', {
          title: 'Aucun produit',
          body: 'Ajoutez des produits avant de créer des deals',
        })
        this.$router.back()
        return
      }
      this.products = data
    },
    // Soumission du formulaire
    handleSubmit(formData) {
      console.log('Données du formulaire:', formData)
      this.$Events.dispatchEvent('new_deal_ready_to_be_added', formData)
      this.$Events.dispatchEvent('start_loading')
    },
    // Gestion de la création réussie
    onDealCreated(data) {
      console.log(data)
      let title = 'Deal Crée'
      let body = 'Votre deal a été créé avec succès'
      if (!data.atLeastOneCreated) {
        title = 'Deal non créé'
        body = "Nous n'avons pas pu créer votre deal, veuillez réessayer"
      }
      if (data.allDealCreated) {
        title = 'Deal non créé'
        body = "Tous les produits sélectionnés bénéficient d'un discount"
      }
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        title,
        body,
      })
      this.$router.back()
    },
    // Gestion de l'échec de la création
    onDealCreationFailed() {
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Deal non créé',
        body: 'Erreur de création du deal, veuillez réessayer',
      })
    },
    toggleProductSelection(product, position) {
      if (this.selectedProductsIds.includes(product.id)) {
        this.selectedProducts.splice(
          this.selectedProductsIds.indexOf(product.id),
          1,
        )
      } else if (this.selectedProducts.length >= this.maxProductsSelectable) {
        this.$Events.dispatchEvent('toast_notification', {
          title: 'Limite atteinte',
          body: `Vous ne pouvez pas sélectionner plus de ${this.maxProductsSelectable} produits`,
        })
        return
      } else this.selectedProducts.push(product)
    },
    async acceptSelectedProducts() {
      const details = await this.askDealDetails()
      if (!details) return
      const dealsData = {
        ...details,
        products: this.selectedProducts,
      }

      this.$Events.dispatchEvent('many_deals_ready_to_be_added', dealsData)
      this.$Events.dispatchEvent('start_loading')
    },
    async askDealDetails() {
      const prompt = await this.$Events.sendDataRequestResolve(
        'customPrompt',
        {
          title: 'Configurez votre deal',
          // subTitle: 'Sélectionnez la couleur et sélectionner une image qui y',
          formFields: [
            {
              type: 'date',
              propertyName: 'startDate',
              label: 'Date de début',
              inputProps: {},
              defaultValue: this.$Commons.time(Date.now(), 'YYYY-MM-DD'),
              required: true,
            },
            {
              type: 'date',
              propertyName: 'endDate',
              label: 'Date de fin',
              defaultValue: this.$Commons.time(
                Date.now() + 24 * 60 * 60 * 1000,
                'YYYY-MM-DD',
              ),
              required: true,
            },
            {
              type: 'number',
              propertyName: 'discount',
              label: 'Réduction',
              inputProps: {
                suffix: '%',
                min: '0.1',
                max: '100',
                placeHolder: 'Appliquer une réduction',
                numberStep: 0.01,
              },
              defaultValue: 5,
              class: '',
              required: true,
            },
          ],
          successText: 'Ajouter',
        },
        9999999999,
      )
      if (!prompt.accepted) return null
      return {
        discount: prompt.data.discount,
        startDate:
          moment(prompt.data.startDate)
            .set('h', 0)
            .set('minute', 0)
            .set('s', 0)
            .unix() * 1000,
        endDate:
          moment(prompt.data.endDate)
            .set('h', 23)
            .set('minute', 59)
            .set('s', 59)
            .unix() * 1000,
      }
    },
  },
  computed: {
    selectedProductsIds() {
      return this.selectedProducts.map(product => product.id)
    },
    maxProductsSelectable() {
      if (this.subscription.isActive) return 20
      return 10
    },
  },
})
</script>

<style scoped></style>
